import { ConfigState } from './types';
import appConfig from '@/config';

export default <ConfigState>{
    staticConfig: appConfig,
    localConfig: {},
    values: appConfig,
};
